import { render, staticRenderFns } from "./BusyLogo.vue?vue&type=template&id=bc50f91c&scoped=true&"
import script from "./BusyLogo.vue?vue&type=script&lang=ts&"
export * from "./BusyLogo.vue?vue&type=script&lang=ts&"
import style0 from "./BusyLogo.vue?vue&type=style&index=0&id=bc50f91c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc50f91c",
  null
  
)

export default component.exports